import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getProject } from "../../store/actions/projects_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/projects_enum";
import SingleView from "../../components/common/SingleView";
const ViewProject = ({ getProject, match, project: { loading, project } }) => {
  useEffect(() => {
    getProject(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Projects"
          mainLinkTitle="Projects"
          mainLinkUrl="/projects"
          activeLink="View"
        />
        {!loading ? (
          project && (
            <SingleView
              data={project}
              inputFields={inputFields}
              label="Project"
              link="projects"
              id={project.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ project: state.project });

const mapDispatchToProps = { getProject };

export default connect(mapStateToProps, mapDispatchToProps)(ViewProject);
